<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="service flex flex-center">
      <div class="service-inner flex">
        <div class="service-cont flex-1" v-loading="detailLoading">
          <Service
            :info="serveDetail"
            :unitMap="unitMap"
            @openConsult="openConsult"
          />
          <!--下单流程-->
          <Flow />
          <div class="tabs">
            <el-tabs v-model="tabNavIndex">
              <el-tab-pane
                :label="item.title"
                :name="item.key"
                v-for="(item, index) in tabNav"
                :key="index"
              ></el-tab-pane>
            </el-tabs>
            <ServiceDetail
              :info="serveDetail"
              :lab="labDetail"
              v-show="tabNavIndex === 'one'"
            />
            <EvaluateList v-show="tabNavIndex === 'two'" mallType="0" />
          </div>
          <Advantage />
        </div>
        <div class="service-right">
          <!-- 实验室信息 -->
          <Laboratory :data="labDetail" />
          <!-- 最新服务 -->
          <NewService :goods="newServices" :unitMap="unitMap" />
          <!-- 热门推荐-->
          <HotService :goods="hotServices" :unitMap="unitMap" />
        </div>
      </div>
    </div>
    <FootBar />
    <ConsultDialog
      v-model="consultVisible"
      v-if="consultVisible"
      :customer="customer"
    />
  </div>
</template>
<script>
import { deviceDetail, mallList, labInfo } from "@/api/mall";
import Service from "./components/Service";
import Laboratory from "./components/Laboratory";
import ServiceDetail from "./components/ServiceDetail";
import NewService from "./components/NewService";
import HotService from "./components/HotService";
import Advantage from "./components/Advantage.vue";
import Flow from "./components/Flow.vue";
import { SERVICE_UNIT_TYPE } from "@/constant/dict";
import ConsultDialog from "@/components/ConsultDialog/index";
import EvaluateList from "@/components/EvaluateList/index";
export default {
  components: {
    ConsultDialog,
    Service,
    Laboratory,
    ServiceDetail,
    NewService,
    HotService,
    Flow,
    Advantage,
    EvaluateList,
  },
  data() {
    return {
      serveDetail: {},
      detailLoading: false,
      newServices: [], // 最新服务
      hotServices: [], // 最热服务
      labDetail: {}, // 商户信息
      unitMap: {},
      consultVisible: false,
      customer: {}, // 客服信息
      tabNav: [
        { title: "基本信息", key: "one" },
        /*{ title: "用户评价", key: "two" },*/
      ],
      tabNavIndex: "one",
    };
  },
  async created() {
    this.getDicts();
    await this.getDetail();
    this.getNewService();
    this.getHotService();
    this.getBusinessInfo(); // 服务方信息
  },
  methods: {
    // 打开咨询客服弹窗
    openConsult(customer) {
      this.customer = customer;
      this.consultVisible = true;
    },
    async getDicts() {
      const units = await this.$store.dispatch(
        "getDictData",
        SERVICE_UNIT_TYPE
      );
      const unitMap = {};
      units.forEach((item) => {
        unitMap[item.dictValue] = item.dictLabel;
      });
      this.unitMap = unitMap;
    },
    async getDetail() {
      this.detailLoading = true;
      const data = await this.$axios
        .get(deviceDetail, {
          id: this.$route.query.id,
        })
        .finally(() => {
          this.detailLoading = false;
        });
      this.serveDetail = data;
    },
    // 服务方信息
    async getBusinessInfo() {
      const data = await this.$axios.get(labInfo, {
        businessId: this.serveDetail.checkmallBusinessId,
      });
      this.labDetail = data;
    },
    // 最新服务
    async getNewService() {
      const { list } = await this.$axios.post(mallList, {
        businessId: this.serveDetail.checkmallBusinessId,
        pageIndex: 1,
        pageSize: 4,
      });
      this.newServices = list;
    },
    // 热门服务
    async getHotService() {
      const { list } = await this.$axios.post(mallList, {
        serviceCategoryIds: [this.serveDetail.serviceCategoryId],
        pageIndex: 1,
        pageSize: 4,
      });
      this.hotServices = list;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.tabs {
  background: white;
  padding: 8px 20px 20px 20px;
  ::v-deep .el-tabs__active-bar {
    opacity: 0;
  }
  /deep/ .el-tabs__item {
    font-size: 16px;
    background: #eaeaea;
    padding: 0 20px !important;
    text-align: center;
    color: #333;
    &.is-active {
      background: $theme-color;
      color: #fff;
    }
  }
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
}
.service {
  background: $home-bg;
  padding-top: 20px;
  padding-bottom: 20px;
  &-inner {
    width: $max-width;
  }
  &-cont {
    margin-right: 20px;
  }
  &-right {
    width: 390px;
  }
  &-intro {
    // border: 1px solid $border-color;
    border-radius: $border-radius;
    margin-bottom: 20px;
    &.super {
      margin-bottom: 40px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
}
</style>
